import {
  Field,
  ID,
  ObjectType,
  registerEnumType,
} from '@warebee/shared/util-backend-only-types';

export enum ProximityPolicyComplianceItemStatus {
  COMPLIANT = 'COMPLIANT',
  NONCOMPLIANT = 'NONCOMPLIANT',
}

registerEnumType(ProximityPolicyComplianceItemStatus, {
  name: 'ProximityPolicyComplianceItemStatus',
});

@ObjectType()
export class ProximityPolicyComplianceSummary {
  @Field()
  compliantCount: number;

  @Field()
  nonCompliantCount: number;
}

@ObjectType()
export class ProximityPolicyComplianceConflictingItem {
  @Field(() => ID)
  locationId: string;

  @Field(() => ID)
  itemId: string;

  @Field(() => ID)
  consignee: string;

  @Field(() => ID)
  sku: string;

  @Field()
  distance: number;
}

@ObjectType()
export class ProximityPolicyComplianceItemRuleSummary {
  @Field(() => ID, { nullable: true })
  ruleId?: string;

  @Field(() => ProximityPolicyComplianceItemStatus)
  status: ProximityPolicyComplianceItemStatus;

  @Field(() => [ProximityPolicyComplianceConflictingItem], { nullable: true })
  conflictingItems?: ProximityPolicyComplianceConflictingItem[];
}

@ObjectType()
export class ProximityPolicyComplianceItemSummary {
  @Field(() => [ProximityPolicyComplianceItemRuleSummary], { nullable: true })
  rules?: ProximityPolicyComplianceItemRuleSummary[];
}
